export default function stringShortener(text, left, right) {
  if (text.length > left + right) {
    return (
      text.substring(0, left) +
      "..." +
      text.substring(text.length - right, text.length)
    );
  } else return text;
}
